// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    GetIntegrationJdByIdParam,
    BaseResponseIntegrationConfigFoundResponse,
    PutIntegrationJdByIdParam,
    PutIntegrationJdByIdBody,
    BaseResponseVoid,
    DeleteIntegrationJdByIdParam,
} from '../../../types';

/**
 * findById
 *
 * @export
 * @tags integration-config-controller
 * @link [GET] /integration/jd/{id}
 * @param id
 */
export function getIntegrationJdById(
    options: ApiOptions<GetIntegrationJdByIdParam, never> & { segments: GetIntegrationJdByIdParam }
): Promise<BaseResponseIntegrationConfigFoundResponse> {
    return request<never, GetIntegrationJdByIdParam, never>('/integration/jd/{id}', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getIntegrationJdById',
    });
}

/**
 * update
 *
 * @export
 * @tags integration-config-controller
 * @link [PUT] /integration/jd/{id}
 * @param id
 */
export function putIntegrationJdById(
    data: PutIntegrationJdByIdBody,
    options: ApiOptions<PutIntegrationJdByIdParam, never> & { segments: PutIntegrationJdByIdParam }
): Promise<BaseResponseVoid> {
    return request<PutIntegrationJdByIdBody, PutIntegrationJdByIdParam, never>(
        '/integration/jd/{id}',
        { ...options, data, method: 'put', __$requestCalleeName: 'putIntegrationJdById' }
    );
}

/**
 * deleteById
 *
 * @export
 * @tags integration-config-controller
 * @link [DELETE] /integration/jd/{id}
 * @param id
 */
export function deleteIntegrationJdById(
    options: ApiOptions<DeleteIntegrationJdByIdParam, never> & {
        segments: DeleteIntegrationJdByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<never, DeleteIntegrationJdByIdParam, never>('/integration/jd/{id}', {
        ...options,
        method: 'delete',
        __$requestCalleeName: 'deleteIntegrationJdById',
    });
}

export const meta = [
    { tags: ['integration-config-controller'], path: '/integration/jd/{id}', method: 'get' },
    { tags: ['integration-config-controller'], path: '/integration/jd/{id}', method: 'put' },
    { tags: ['integration-config-controller'], path: '/integration/jd/{id}', method: 'delete' },
];
